<template>
  <div>
    <transition mode="out-in" name="slide-fade">
      <router-view />
    </transition>
    <ModalRoot />
  </div>
</template>

<script>
import ModalRoot from './modules/modals/components/ModalRoot'
import {mapActions} from 'vuex'
export default {
      components: {
        ModalRoot,
      },
      methods: {
        ...mapActions({
        })
      },
      mounted(){
      }
}

</script>
<style lang="sass">
$pureNavy: #00283A
$pureNavy2: #153c57
$sparkYellow: #FBE025
$steelBlue: #7b98ac
$trueGray: #E2E2E2
$starkWhite: #FFFFFF
$lightGray: #F1F2F2

$navy: #141935
$cyan: #22E0DB
html
  min-height: 100vh
  font-size: 16px
.sideNav_link, .sideNav_sublink-link
  font-family: 'Barlow', sans-serif
.sideNav_link
  font-size: 18px
.sideNav_sublink-link
  font-size: 15px
.page_content-dashboard.full
  height: auto !important
  overflow-y: auto !important
.page_contentBody
  scroll-behavior: smooth
  padding-bottom: 60px
body
  margin: 0
::selection
  color: white
  background: #141935
#app
  .tippy-box[data-theme~='trg']
    background-color: $pureNavy2
  .btn-report
    @apply px-4
    @apply py-2
    @apply rounded-full
    @apply text-white
    &.cyan
      @apply bg-cyan
    &.navy
      @apply bg-navy
    &.navy2
      @apply bg-navy2
    &.outline
      background-color: transparent
      border-width: 1px
      &.white
        border-color: white
  font-family: Barlow, Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: $pureNavy
  background-color: $trueGray
  padding: 1rem
  h1
    font-style: normal
    font-weight: 600
    font-size: 32px
    line-height: 38px
    padding-bottom: 1rem
  a
    font-weight: bold
    color: #2c3e50
  input[type="checkbox"]
    appearance: none
    &:focus
      outline: none
    &:checked
      position: relative
      &:before
        content: "\2714"
        font-size: 20px
        color: $navy
        line-height: 21px
        position: absolute
        top: 0
        left: 4px
.v-popper
  &__arrow-inner, &__arrow-outer
    display: none
  &__popper
    font-family: Barlow, Avenir, Helvetica, Arial, sans-serif
  &__inner
    color: $pureNavy!important
    @apply text-sm
    ul li
      @apply text-xs
.tooltip
  display: block !important
  z-index: 10000
  $color: rgba($pureNavy, .9)
  @apply text-xs
  .tooltip-inner
      background: $color
      color: white
      padding: 1rem
      border-radius: 7px
      box-shadow: 0 5px 30px rgba(black, .1)
      max-width: 250px
  .tooltip-arrow
    width: 0
    height: 0
    border-style: solid
    position: absolute
    margin: 5px
    border-color: black
    z-index: 1
  &[x-placement^="top"]
    margin-bottom: 5px
    .tooltip-arrow
      border-width: 5px 5px 0 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      bottom: -5px
      left: calc(50% - 5px)
      margin-top: 0
      margin-bottom: 0
  &[x-placement^="bottom"]
    margin-top: 5px
    .tooltip-arrow
      border-width: 0 5px 5px 5px
      border-left-color: transparent !important
      border-right-color: transparent !important
      border-top-color: transparent !important
      top: -5px
      left: calc(50% - 5px)
      margin-top: 0
      margin-bottom: 0
  &[x-placement^="right"]
    margin-left: 5px
    .tooltip-arrow
      border-width: 5px 5px 5px 0
      border-left-color: transparent !important
      border-top-color: transparent !important
      border-bottom-color: transparent !important
      left: -5px
      top: calc(50% - 5px)
      margin-left: 0
      margin-right: 0
  &[x-placement^="left"]
    margin-right: 5px
    .tooltip-arrow
      border-width: 5px 0 5px 5px
      border-top-color: transparent !important
      border-right-color: transparent !important
      border-bottom-color: transparent !important
      right: -5px
      top: calc(50% - 5px)
      margin-left: 0
      margin-right: 0
  &.popover
    $color: #f9f9f9
    .popover-inner
      background: $color
      color: black
      padding: 24px
      border-radius: 5px
      box-shadow: 0 5px 30px rgba(black, .1)
    .popover-arrow
      border-color: $color
  &[aria-hidden='true']
    visibility: hidden
    opacity: 0
    transition: opacity .15s, visibility .15s
  &[aria-hidden='false']
    visibility: visible
    opacity: 1
    transition: opacity .15s
.form
  label
    @apply block
    @apply text-gray-500
    @apply text-sm
    @apply font-normal
    margin-bottom: 16px
    text-transform: capitalize
  input:not(.multiselect__input)
    @apply p-2
    @apply w-full
    border-radius: 5px
    border: 1px solid #e8e8e8
    background-color: #ffffff
    min-height: 40px
    font-size: 14px
  input:focus-visible
    outline: none
.dashb
  .push
    margin-left: auto!important
  .multiselect
    &__placeholder
      padding-top: 0
    &__option--highlight, &__tag
      background-color: rgba($steelBlue, .4)
      color: $pureNavy
    &__tag
      &-icon:after
        color: $pureNavy
      &-icon:focus, &-icon:hover
        background-color: $pureNavy
        &-icon:after
          color: #fff
  .tab-wrapper.grid
    grid-template-columns: repeat(auto-fill,minmax(310px, 1fr))
  .fade-enter-active, .fade-leave-active
    transition: opacity 0.3s
  .fade-enter, .fade-leave-to
    opacity: 0
  .slide-fade-enter-active
    transition: all .1s ease
  .slide-fade-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)
  .slide-fade-enter, .slide-fade-leave-to
    transform: translateX(10px)
    opacity: 0
</style>
